<template>
  <BaseVeeForm
    :action="submit"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
    @success="showActions = false"
  >
    <ValidationProvider rules="required" name="mediaId" slim vid="mediaId">
      <template #default="{ errors }">
        <BaseFormInput type="hidden" :value="mediaId" />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>
    <BaseButton primary small :disabled="isPending || invalid"> Set as Cover </BaseButton>
  </BaseVeeForm>
</template>

<script>
export default {
  inject: ['updateAccProductTemplate'],
  props: {
    mediaId: {
      type: String,
      required: true,
    },
  },
  methods: {
    async submit() {
      try {
        await this.updateAccProductTemplate({ coverMediaId: this.mediaId });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
